import { Divider, Tooltip } from "@mui/material";
import React from "react";

import MDAvatar from "@/components/atoms/MDAvatar";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { getAvatarLetters } from "@/helpers/profile-helpers";
import useContactData from "@/hooks/data/use-contact-data";
import IContact from "@/interfaces/contact.interface";
import { ChatContactListMessages } from "@/messages/chat/contact-list.messages";

type ListItemProps = {
  contact: IContact;
  onSelect: (contact: IContact) => void;
  messages: ChatContactListMessages;
};

const ListItem: React.FC<ListItemProps> = ({ contact, messages, onSelect }) => {
  const { fullName } = useContactData({ contact, messages });
  const isInactive = contact.active === false;

  return (
    <>
      <Tooltip
        title={isInactive ? messages.startConversationInactive : ""}
        disableHoverListener={!isInactive}
      >
        <MDBox
          display="flex"
          alignItems="center"
          gap={2}
          p={1}
          borderRadius={"xl"}
          mt={0.5}
          sx={(theme) => ({
            opacity: isInactive ? 0.5 : 1,
            "&:hover": isInactive
              ? { cursor: "not-allowed" }
              : { cursor: "pointer", background: theme.palette.grey[300] },
          })}
          onClick={() => {
            if (isInactive) return;
            onSelect(contact);
          }}
        >
          <MDAvatar size="md" bgColor="light">
            {getAvatarLetters(fullName)}
          </MDAvatar>

          <MDTypography
            variant="button"
            fontWeight="bold"
            sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
          >
            {fullName}
          </MDTypography>
        </MDBox>
      </Tooltip>
      <Divider sx={{ margin: 0 }} />
    </>
  );
};
export default ListItem;
